import { z } from 'zod';
export const SearchSchema = z.object({
  patternId: z.string().optional(),
  targetId: z.string().optional(),
  targetName: z.string().optional(),
  pageIndex: z.number().optional(),
  pageSize: z.number().optional()
});
export type SearchSchema = z.infer<typeof SearchSchema>;